var Raven;
export const RavenUrl = 'http://261d3119dcf346aaa9e7bd1581b8cc49@taming.io/3';

var ravenOptions = {
  whitelistUrls: [/arena4game\.com/, /pointblank\.kindbeetle\.ru/]
};

if (typeof window !== 'undefined') {
  Raven = require('raven-js');
  require('raven-js/plugins/native');
  Raven.config(RavenUrl, ravenOptions).install();
}

export default Raven;



// WEBPACK FOOTER //
// ./src/raven-config.js